var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCookieImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 291.923,
    height: 301,
    viewBox: "0 0 291.923 301",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6786",
    "data-name": "Group 6786",
    transform: "translate(-197.95 -275.626)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1200",
    "data-name": "Ellipse 1200",
    cx: 52.5,
    cy: 5.5,
    rx: 52.5,
    ry: 5.5,
    transform: "translate(270.814 565.626)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6607",
    "data-name": "Group 6607",
    transform: "translate(432.537 441.701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6604",
    "data-name": "Group 6604",
    transform: "translate(0 17.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14947",
    "data-name": "Path 14947",
    d: "M1091.6,992.505a24.819,24.819,0,0,1-6.962-1.022c-5.472-1.6-10.881-4.994-16.078-10.1a3.535,3.535,0,0,1,4.952-5.045c8.207,8.056,16.63,10.9,23.717,8.01,7.825-3.191,12.843-12.849,13.094-25.205a3.535,3.535,0,0,1,3.533-3.463h.073a3.534,3.534,0,0,1,3.462,3.606c-.31,15.223-7.013,27.334-17.493,31.607A21.885,21.885,0,0,1,1091.6,992.505Z",
    transform: "translate(-1067.501 -955.685)",
    fill: "#133441"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6606",
    "data-name": "Group 6606",
    transform: "translate(37.436)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6605",
    "data-name": "Group 6605"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14948",
    "data-name": "Path 14948",
    d: "M1215.456,918.1a7.874,7.874,0,0,1-2.4-.366c-1.892-.6-6.245-2.872-5.792-10.922.365-6.478-.466-9.009-.569-9.294a4.391,4.391,0,0,1,7.807-4.015c.364.664,1.318,2.839,1.572,7.706a14.463,14.463,0,0,1,4.14-.024,6.921,6.921,0,0,1,4.844,2.856c1.612,2.353,1.45,5.435-.443,8.455a12.681,12.681,0,0,1-4.755,4.467A9.534,9.534,0,0,1,1215.456,918.1Zm-8.655-20.385.007.012Zm0-.005,0,.005Zm-.108-.219Z",
    transform: "translate(-1206.265 -891.221)",
    fill: "#133441"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6611",
    "data-name": "Group 6611",
    transform: "translate(197.95 458.251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6608",
    "data-name": "Group 6608"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14949",
    "data-name": "Path 14949",
    d: "M234.316,1005.84a54.253,54.253,0,0,1-20.335-3.782c-7.7-3.173-12.883-7.936-14.993-13.775-2.66-7.363-1.491-19.413,19.184-35a3.535,3.535,0,0,1,4.256,5.644c-13.446,10.139-19.409,19.713-16.792,26.958,2.9,8.019,16.287,13.538,31.143,12.832a3.535,3.535,0,0,1,.334,7.061Q235.715,1005.84,234.316,1005.84Z",
    transform: "translate(-197.95 -952.566)",
    fill: "#133441"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6610",
    "data-name": "Group 6610",
    transform: "translate(33.878 39.269)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6609",
    "data-name": "Group 6609"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14950",
    "data-name": "Path 14950",
    d: "M333.468,1119.552a10.452,10.452,0,0,1-3.17-.478c-4.541-1.445-7.063-5.685-6.745-11.339.411-7.312,4.6-9.739,8.066-9.6a8.772,8.772,0,0,1,5.562,2.506,10.606,10.606,0,0,1,6.858,4.592,7.952,7.952,0,0,1,.111,8.457A12.934,12.934,0,0,1,333.468,1119.552Z",
    transform: "translate(-323.526 -1098.125)",
    fill: "#133441"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6612",
    "data-name": "Group 6612",
    transform: "translate(350.711 522.071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14951",
    "data-name": "Path 14951",
    d: "M775.167,1239.975c-.079,0-.158,0-.238-.008-5.988-.4-9.055-2.685-9.385-2.944a3.535,3.535,0,0,1-1.321-3.234l5.393-41.579a3.534,3.534,0,0,1,7.01.909l-5.069,39.08a15.249,15.249,0,0,0,3.842.714,3.534,3.534,0,0,1-.232,7.061Z",
    transform: "translate(-764.193 -1189.13)",
    fill: "#133441"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6613",
    "data-name": "Group 6613",
    transform: "translate(277.593 522.071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14952",
    "data-name": "Path 14952",
    d: "M496.694,1240.22a3.535,3.535,0,0,1-.635-7.011,37.234,37.234,0,0,0,6.43-1.744c1.867-3.808,6.6-22.669,10.279-39.553a3.535,3.535,0,1,1,6.907,1.506c-.022.1-2.222,10.169-4.72,20.3-1.475,5.979-2.766,10.821-3.839,14.391-2.044,6.8-3.042,8.333-4.507,9.188-2.765,1.615-8.209,2.671-9.273,2.866A3.532,3.532,0,0,1,496.694,1240.22Z",
    transform: "translate(-493.163 -1189.129)",
    fill: "#133441"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6762",
    "data-name": "Group 6762",
    transform: "translate(202.486 275.626)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6618",
    "data-name": "Group 6618",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6615",
    "data-name": "Group 6615"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6614",
    "data-name": "Group 6614"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14953",
    "data-name": "Path 14953",
    d: "M479.317,403.765c.378-20.89-12.683-22-13.835-49.735-1.414-34.042-25.273-42.122-35.311-53.258-12.188-13.521-25.82-13.367-30.707-15.588-7.416-3.371-6.968-8.4-24.394-6.171-12.583,1.611-18.619-4.579-38.759-3.179-21.779,1.515-36.62,6.906-47.207,13.78a113.489,113.489,0,0,0-27.035,20.449c-13.218,14.508-28.048,10.317-39.977,41.589-8.068,21.15,4.836,27.081-4.191,55.775-11.079,35.214,10.265,52.223,16.4,67.263,7.448,18.261,21.4,23.118,25.561,27.18,6.319,6.163,4.012,11.124,22.592,15.261,13.416,2.986,17.292,11.514,38.331,17.494,63.64,18.086,83.141-14.687,98.937-23.387,17.986-9.9,29.66-22.89,37.4-41.589,7.86-19,16.362-25.553,16.553-40.671C476.8,423.315,479.1,415.82,479.317,403.765Z",
    transform: "translate(-214.763 -275.626)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6617",
    "data-name": "Group 6617",
    transform: "translate(5.855 5.236)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6616",
    "data-name": "Group 6616"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14954",
    "data-name": "Path 14954",
    d: "M489.586,416.352c.361-19.778-12.135-20.825-13.237-47.087-1.353-32.23-24.181-39.88-33.785-50.423-11.661-12.8-24.7-12.655-29.38-14.759-7.1-3.192-6.667-7.953-23.34-5.843-12.039,1.525-17.815-4.335-37.084-3.01-20.838,1.434-35.038,6.539-45.167,13.046a108.487,108.487,0,0,0-25.867,19.36c-12.647,13.735-26.836,9.768-38.25,39.375-7.719,20.024,4.627,25.64-4.01,52.806-10.6,33.339,9.821,49.443,15.691,63.682,7.126,17.289,20.473,21.888,24.456,25.733,6.046,5.835,3.838,10.532,21.615,14.449,12.836,2.828,16.544,10.9,36.675,16.563,60.89,17.123,79.548-13.906,94.661-22.142,17.208-9.378,28.379-21.671,35.782-39.375,7.521-17.984,15.655-24.193,15.838-38.506C487.178,434.86,489.377,427.764,489.586,416.352Z",
    transform: "translate(-236.465 -295.034)",
    fill: "#f9b95a"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6731",
    "data-name": "Group 6731",
    transform: "translate(19.368 15.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6620",
    "data-name": "Group 6620",
    transform: "translate(63.149 15.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6619",
    "data-name": "Group 6619"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14955",
    "data-name": "Path 14955",
    d: "M530.727,388.194l-3.36.754a11.332,11.332,0,0,0-4.046,1.289,5.5,5.5,0,0,0,4.233,10.04,46.353,46.353,0,0,0,5.944-2.033,5.27,5.27,0,0,0,3.64-6.411A5.328,5.328,0,0,0,530.727,388.194Z",
    transform: "translate(-520.633 -388.046)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6622",
    "data-name": "Group 6622",
    transform: "translate(144.947 19.353)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6621",
    "data-name": "Group 6621"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14956",
    "data-name": "Path 14956",
    d: "M837.5,410.471a11.889,11.889,0,0,0-3.34-5.137,5.424,5.424,0,0,0-4.6-1.507,4.042,4.042,0,0,0-1.422.332,4.97,4.97,0,0,0-.956.289,4.862,4.862,0,0,0-2.474,2.117,7.251,7.251,0,0,0,.38,7.55c1.48,2.119,3.981,4.114,6.665,4.158A6.048,6.048,0,0,0,837.5,410.471Z",
    transform: "translate(-823.834 -403.774)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6624",
    "data-name": "Group 6624",
    transform: "translate(19.838 63.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6623",
    "data-name": "Group 6623"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14957",
    "data-name": "Path 14957",
    d: "M373.244,571.466c-.022-.166-.058-.327-.1-.487a4.393,4.393,0,0,0-1.721-3.832,4.564,4.564,0,0,0-5.086-.358,12.685,12.685,0,0,0-4.154,4.317,11.64,11.64,0,0,0-1.694,3.116c-1.328,3.73.677,8.151,4.989,8.277C370.5,582.645,375.174,576.032,373.244,571.466Z",
    transform: "translate(-360.088 -566.174)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6626",
    "data-name": "Group 6626",
    transform: "translate(190.687 74.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6625",
    "data-name": "Group 6625"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14958",
    "data-name": "Path 14958",
    d: "M1004.806,611.828a14.5,14.5,0,0,0-.729-1.7,3.719,3.719,0,0,0-.2-.351l-.026-.042a5.43,5.43,0,0,0-4.966-3.367,6.32,6.32,0,0,0-2.69.728,5.669,5.669,0,0,0-2.45,3.186,8.361,8.361,0,0,0-.225,4.079,9.155,9.155,0,0,0,1.3,3.9,5.921,5.921,0,0,0,6.865,2.468,5.38,5.38,0,0,0,3.69-3.807,7.077,7.077,0,0,0-.315-4.114A6.968,6.968,0,0,0,1004.806,611.828Z",
    transform: "translate(-993.382 -606.362)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6628",
    "data-name": "Group 6628",
    transform: "translate(89.451 125.915)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6627",
    "data-name": "Group 6627"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14959",
    "data-name": "Path 14959",
    d: "M629.551,804.236a14.486,14.486,0,0,0-.729-1.7,3.691,3.691,0,0,0-.2-.351l-.026-.042a5.43,5.43,0,0,0-4.966-3.367,6.326,6.326,0,0,0-2.69.728,5.669,5.669,0,0,0-2.45,3.185,8.356,8.356,0,0,0-.225,4.079,9.15,9.15,0,0,0,1.3,3.9,5.921,5.921,0,0,0,6.865,2.468,5.381,5.381,0,0,0,3.69-3.807,7.078,7.078,0,0,0-.315-4.114A6.9,6.9,0,0,0,629.551,804.236Z",
    transform: "translate(-618.127 -798.769)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6630",
    "data-name": "Group 6630",
    transform: "translate(130.214 61.679)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6629",
    "data-name": "Group 6629"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14960",
    "data-name": "Path 14960",
    d: "M783.88,568.848a10.4,10.4,0,0,0-7.338-7.88l-.155-.062a4.609,4.609,0,0,0-2.96,0,5.3,5.3,0,0,0-4.05,4.329,6.967,6.967,0,0,0-.145,1.119A9.634,9.634,0,0,0,775.3,575.5a15.234,15.234,0,0,0,1.518.686c3.145,1.221,7.312-1.871,7.141-5.229A7.686,7.686,0,0,0,783.88,568.848Z",
    transform: "translate(-769.223 -560.664)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6632",
    "data-name": "Group 6632",
    transform: "translate(59.157 138.405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6631",
    "data-name": "Group 6631"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14961",
    "data-name": "Path 14961",
    d: "M509.421,846.8a10.4,10.4,0,0,0-3.322,10.242c.008.056.013.11.021.165a4.611,4.611,0,0,0,1.441,2.586,5.3,5.3,0,0,0,5.751,1.436,6.959,6.959,0,0,0,1.049-.416,9.635,9.635,0,0,0,5.046-9.745,15.243,15.243,0,0,0-.138-1.659c-.461-3.343-5.188-5.481-8.039-3.7A7.689,7.689,0,0,0,509.421,846.8Z",
    transform: "translate(-505.835 -845.066)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6634",
    "data-name": "Group 6634",
    transform: "translate(34.939 117.888)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6633",
    "data-name": "Group 6633"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14962",
    "data-name": "Path 14962",
    d: "M426.939,772.723a5.241,5.241,0,0,0-3.529-3.529,5.078,5.078,0,0,0-4.916,1.3,7.261,7.261,0,0,0-.583.678,7.6,7.6,0,0,0-1.476,7.226,8.152,8.152,0,0,0,.466,1.857,4.769,4.769,0,0,0,8.664,1.133,9.656,9.656,0,0,0,1.493-4.266A7.369,7.369,0,0,0,426.939,772.723Z",
    transform: "translate(-416.065 -769.016)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6636",
    "data-name": "Group 6636",
    transform: "translate(147.39 144.939)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6635",
    "data-name": "Group 6635"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14963",
    "data-name": "Path 14963",
    d: "M843,872.05c-1.355-2.2-3.527-3.479-6.88-2.337a.762.762,0,0,0-.158.08,6.492,6.492,0,0,0-2.118,2.543,7.6,7.6,0,0,0,0,7.374,8.15,8.15,0,0,0,.828,1.726,4.77,4.77,0,0,0,8.716-.625,9.654,9.654,0,0,0,.609-4.478A7.366,7.366,0,0,0,843,872.05Z",
    transform: "translate(-832.891 -869.287)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6638",
    "data-name": "Group 6638",
    transform: "translate(14.791 158.555)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6637",
    "data-name": "Group 6637"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14964",
    "data-name": "Path 14964",
    d: "M351.246,924.327a7.714,7.714,0,0,0-1.572-2.747c-.042-.046-.088-.087-.131-.131-.122-.124-.235-.258-.368-.368a7.237,7.237,0,0,0-.682-.5,4.127,4.127,0,0,0-1.269-.636c-.033-.009-.067-.01-.1-.018a4.191,4.191,0,0,0-2.348-.013,4.521,4.521,0,0,0-3.158,3.158,7.353,7.353,0,0,0,.34,4.716,6.224,6.224,0,0,0,1.413,2.193,4.749,4.749,0,0,0,2.67,1.3,4.4,4.4,0,0,0,5.3-3.051c.028-.144.044-.289.068-.434a4.722,4.722,0,0,0,.081-.52A6.781,6.781,0,0,0,351.246,924.327Z",
    transform: "translate(-341.382 -919.757)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6640",
    "data-name": "Group 6640",
    transform: "translate(185.794 148.325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6639",
    "data-name": "Group 6639"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14965",
    "data-name": "Path 14965",
    d: "M986.964,883.459a4.139,4.139,0,0,0-.346-.424,4.236,4.236,0,0,0-5.9,0c-.207.2-.391.409-.582.617-2.992,2.125-4.518,5.857-4.873,9.519-.357,3.685,3.79,6.184,7.043,5.28a5.951,5.951,0,0,0,4.686-3.626,15.393,15.393,0,0,0,2.271-4.138,4.814,4.814,0,0,0-.541-4.379A5.256,5.256,0,0,0,986.964,883.459Z",
    transform: "translate(-975.243 -881.839)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6642",
    "data-name": "Group 6642",
    transform: "translate(209.078 113.969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6641",
    "data-name": "Group 6641"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14966",
    "data-name": "Path 14966",
    d: "M1069.75,763.261a4.478,4.478,0,0,0,1.328-3.206,8.154,8.154,0,0,0-.253-1.572,4.991,4.991,0,0,0-1.242-2.518,3.058,3.058,0,0,0-1.08-1.023,4.032,4.032,0,0,0-2.652-.373,3.98,3.98,0,0,0-1.911.574l-.939.726a5.3,5.3,0,0,0-1.359,4.508q-.027.206-.055.412a3.257,3.257,0,0,0,.373,1.668,4.131,4.131,0,0,0,1.771,2.07,4.479,4.479,0,0,0,5.15-.6A3.6,3.6,0,0,0,1069.75,763.261Z",
    transform: "translate(-1061.551 -754.49)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6644",
    "data-name": "Group 6644",
    transform: "translate(159.489 114.778)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6643",
    "data-name": "Group 6643"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14967",
    "data-name": "Path 14967",
    d: "M886.389,761.027a3.466,3.466,0,0,0-.487-1.8,3.535,3.535,0,0,0-1.706-1.459,3.4,3.4,0,0,0-1.848-.244,3.256,3.256,0,0,0-2.048.981c-.322.407-.64.82-.969,1.223a2.813,2.813,0,0,0-.291.258,5.036,5.036,0,0,0-1.049,1.761c-.031.08-.061.161-.087.243,0,.012-.009.022-.012.034h0a3.338,3.338,0,0,0-.154,1.127,4.382,4.382,0,0,0,.911,2.57,4.225,4.225,0,0,0,5.473,1.093,4.667,4.667,0,0,0,1.666-1.622,5.89,5.89,0,0,0,.6-2.3,2.816,2.816,0,0,0-.08-1C886.336,761.609,886.365,761.318,886.389,761.027Z",
    transform: "translate(-877.737 -757.489)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6646",
    "data-name": "Group 6646",
    transform: "translate(81.286 49.649)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6645",
    "data-name": "Group 6645"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14968",
    "data-name": "Path 14968",
    d: "M599.1,524.158a3.542,3.542,0,0,0,.978-1.523,4.541,4.541,0,0,0,.238-3.081,5.622,5.622,0,0,0-1.217-2.088,4.7,4.7,0,0,0-3.346-1.386,41.182,41.182,0,0,0-4.51.611,4.667,4.667,0,0,0-2.785,2.142,4.8,4.8,0,0,0-.553,2.971c.282,2.1,2.267,4.278,4.577,4.041.461-.011.92-.044,1.377-.084a4.594,4.594,0,0,0,1.077.134c1.254.161,2.154-.541,3.2-1Z",
    transform: "translate(-587.86 -516.071)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6648",
    "data-name": "Group 6648",
    transform: "translate(48.41 191.296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6647",
    "data-name": "Group 6647"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14969",
    "data-name": "Path 14969",
    d: "M471.414,1041.22a4.4,4.4,0,0,0-4.527,1.544,4.076,4.076,0,0,0-.848,2.037,4.787,4.787,0,0,0,.511,2.746,7.6,7.6,0,0,0,4.593,4.175,4.46,4.46,0,0,0,5.041-2.185,3.974,3.974,0,0,0,.679-1.771,4.665,4.665,0,0,0-.5-2.683A7.111,7.111,0,0,0,471.414,1041.22Z",
    transform: "translate(-466 -1041.118)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6650",
    "data-name": "Group 6650",
    transform: "translate(154.156 176.365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6649",
    "data-name": "Group 6649"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14970",
    "data-name": "Path 14970",
    d: "M864.4,994.544a4.221,4.221,0,0,0,.9-.719,4.514,4.514,0,0,0,.616-.8l.04-.052-.04.051a4.383,4.383,0,0,0,.227-.444,4.642,4.642,0,0,0,.649-1.09A3.959,3.959,0,0,0,867,988.8a4.215,4.215,0,0,0-3.978-3.029,5.084,5.084,0,0,0-3.675,1.6,4.93,4.93,0,0,0-1.373,3.244,4.533,4.533,0,0,0,1.117,2.959,3.505,3.505,0,0,0,.252.386,3.39,3.39,0,0,0,4.169.957A3.142,3.142,0,0,0,864.4,994.544Zm2.127-3.022-.052.121a6.8,6.8,0,0,0,.187-1.127Q866.6,991.019,866.528,991.522Z",
    transform: "translate(-857.971 -985.774)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6652",
    "data-name": "Group 6652",
    transform: "translate(89.604 206.515)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6651",
    "data-name": "Group 6651"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14971",
    "data-name": "Path 14971",
    d: "M622.846,1098.119l-.037-.006a3.812,3.812,0,0,0-.45-.278,2.458,2.458,0,0,0-3.336,3.381,3.066,3.066,0,0,0,.63,1.672,2.988,2.988,0,0,0,3.556.935,3.036,3.036,0,0,0,1.867-2.776A3.07,3.07,0,0,0,622.846,1098.119Z",
    transform: "translate(-618.693 -1097.533)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6654",
    "data-name": "Group 6654",
    transform: "translate(7.04 113.346)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6653",
    "data-name": "Group 6653"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14972",
    "data-name": "Path 14972",
    d: "M317.749,752.426a3.141,3.141,0,0,0-3.907,1.28,8.016,8.016,0,0,0-1.175,4.611,3.525,3.525,0,0,0,2.135,3.174,3.478,3.478,0,0,0,3.795-.718,5.4,5.4,0,0,0,1.084-5.458A3.228,3.228,0,0,0,317.749,752.426Zm.714,6.022h0S318.46,758.451,318.463,758.448Z",
    transform: "translate(-312.653 -752.179)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6656",
    "data-name": "Group 6656",
    transform: "translate(68.601 76.707)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6655",
    "data-name": "Group 6655"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14973",
    "data-name": "Path 14973",
    d: "M549.393,617.021a3.2,3.2,0,0,0-4.011.122c-1.682.477-3.062,2.126-4,3.467a3.658,3.658,0,0,0,0,3.82,5.72,5.72,0,0,0,1.075,1.195,5.349,5.349,0,0,0,1.44.737,3.493,3.493,0,0,0,2.454-.19A3.722,3.722,0,0,0,548,624.848a4.2,4.2,0,0,0,.88-.772,5.823,5.823,0,0,0,1.425-3.155A3.194,3.194,0,0,0,549.393,617.021Zm-4.524.439.038-.01c-.133.089-.264.184-.392.288Z",
    transform: "translate(-540.841 -616.368)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6658",
    "data-name": "Group 6658",
    transform: "translate(130.032 211.473)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6657",
    "data-name": "Group 6657"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14974",
    "data-name": "Path 14974",
    d: "M777.255,1116.448a3.821,3.821,0,0,0-2.831-.435c-.24.053-.476.123-.712.188a7.772,7.772,0,0,0-2.641.363,3.5,3.5,0,0,0-2.489,3.812,3.539,3.539,0,0,0,3.412,3.013,9.073,9.073,0,0,0,3.194-.322,8.723,8.723,0,0,0,1.654-.6,3.756,3.756,0,0,0,1.909-2.348A3.272,3.272,0,0,0,777.255,1116.448Z",
    transform: "translate(-768.548 -1115.91)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6660",
    "data-name": "Group 6660",
    transform: "translate(166.181 52.251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6659",
    "data-name": "Group 6659"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14975",
    "data-name": "Path 14975",
    d: "M910.359,527.063a4.6,4.6,0,0,0-3.24-1.342,4.727,4.727,0,0,0-2.776.984,4.373,4.373,0,0,0-1.642,2.38,4.459,4.459,0,0,0,.462,3.531l.325.437a3.427,3.427,0,0,0,1.055,1.177c.01.01.018.02.028.03l.841.824a4.393,4.393,0,0,0,5.747.342,4.173,4.173,0,0,0,1.569-2.274,4.275,4.275,0,0,0-.441-3.373A21.929,21.929,0,0,0,910.359,527.063Z",
    transform: "translate(-902.545 -525.718)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6662",
    "data-name": "Group 6662",
    transform: "translate(202.474 47.451)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6661",
    "data-name": "Group 6661"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14976",
    "data-name": "Path 14976",
    d: "M1040.823,507.926a3.748,3.748,0,1,0,3.748,3.748A3.79,3.79,0,0,0,1040.823,507.926Z",
    transform: "translate(-1037.072 -507.926)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6664",
    "data-name": "Group 6664",
    transform: "translate(182.734 22.239)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6663",
    "data-name": "Group 6663"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14977",
    "data-name": "Path 14977",
    d: "M966.82,414.47c-3.89,0-3.9,6.045,0,6.045S970.716,414.47,966.82,414.47Z",
    transform: "translate(-963.901 -414.47)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6666",
    "data-name": "Group 6666",
    transform: "translate(124.344 2.954)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6665",
    "data-name": "Group 6665"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14978",
    "data-name": "Path 14978",
    d: "M751.085,350.484c4.823,0,4.831-7.5,0-7.5S746.254,350.484,751.085,350.484Z",
    transform: "translate(-747.465 -342.988)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6668",
    "data-name": "Group 6668",
    transform: "translate(100.515 28.53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6667",
    "data-name": "Group 6667"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14979",
    "data-name": "Path 14979",
    d: "M663.108,437.789c-5.29,0-5.3,8.221,0,8.221S668.407,437.789,663.108,437.789Z",
    transform: "translate(-659.138 -437.789)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6670",
    "data-name": "Group 6670",
    transform: "translate(38.198 33.528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6669",
    "data-name": "Group 6669"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14980",
    "data-name": "Path 14980",
    d: "M431.826,463.932c4.9,0,4.909-7.617,0-7.617S426.916,463.932,431.826,463.932Z",
    transform: "translate(-428.147 -456.315)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6672",
    "data-name": "Group 6672",
    transform: "translate(2.556 91.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6671",
    "data-name": "Group 6671"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14981",
    "data-name": "Path 14981",
    d: "M298.483,672.412c-3.267,0-3.272,5.078,0,5.078S301.756,672.412,298.483,672.412Z",
    transform: "translate(-296.031 -672.412)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6674",
    "data-name": "Group 6674",
    transform: "translate(44.596 80.865)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6673",
    "data-name": "Group 6673"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14982",
    "data-name": "Path 14982",
    d: "M454.956,631.781c-4.123,0-4.13,6.408,0,6.408S459.086,631.781,454.956,631.781Z",
    transform: "translate(-451.861 -631.781)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6676",
    "data-name": "Group 6676",
    transform: "translate(216.778 143.08)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6675",
    "data-name": "Group 6675"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14983",
    "data-name": "Path 14983",
    d: "M1092.661,862.4c-3.422,0-3.428,5.32,0,5.32S1096.09,862.4,1092.661,862.4Z",
    transform: "translate(-1090.093 -862.395)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6678",
    "data-name": "Group 6678",
    transform: "translate(188.972 189.072)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6677",
    "data-name": "Group 6677"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14984",
    "data-name": "Path 14984",
    d: "M990.059,1032.877c-4.045,0-4.052,6.287,0,6.287S994.111,1032.877,990.059,1032.877Z",
    transform: "translate(-987.022 -1032.877)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6680",
    "data-name": "Group 6680",
    transform: "translate(115.14 191.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6679",
    "data-name": "Group 6679"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14985",
    "data-name": "Path 14985",
    d: "M716.386,1040.048c-4.045,0-4.052,6.287,0,6.287S720.438,1040.048,716.386,1040.048Z",
    transform: "translate(-713.349 -1040.048)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6682",
    "data-name": "Group 6682",
    transform: "translate(160.067 208.758)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6681",
    "data-name": "Group 6681"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14986",
    "data-name": "Path 14986",
    d: "M883.269,1105.847c-4.512,0-4.519,7.012,0,7.012S887.788,1105.847,883.269,1105.847Z",
    transform: "translate(-879.883 -1105.847)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6684",
    "data-name": "Group 6684",
    transform: "translate(218.425 90.043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6683",
    "data-name": "Group 6683"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14987",
    "data-name": "Path 14987",
    d: "M1098.944,665.8c-3.656,0-3.662,5.682,0,5.682S1102.606,665.8,1098.944,665.8Z",
    transform: "translate(-1096.2 -665.801)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6686",
    "data-name": "Group 6686",
    transform: "translate(122.143 98.55)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6685",
    "data-name": "Group 6685"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14988",
    "data-name": "Path 14988",
    d: "M742.343,697.334c-4.045,0-4.052,6.287,0,6.287S746.4,697.334,742.343,697.334Z",
    transform: "translate(-739.307 -697.334)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6688",
    "data-name": "Group 6688",
    transform: "translate(121.176 133.37)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6687",
    "data-name": "Group 6687"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14989",
    "data-name": "Path 14989",
    d: "M738.758,826.4c-4.045,0-4.052,6.287,0,6.287S742.81,826.4,738.758,826.4Z",
    transform: "translate(-735.721 -826.403)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6690",
    "data-name": "Group 6690",
    transform: "translate(91.054 97.823)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6689",
    "data-name": "Group 6689"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14990",
    "data-name": "Path 14990",
    d: "M627.513,694.64c-4.59,0-4.6,7.133,0,7.133S632.11,694.64,627.513,694.64Z",
    transform: "translate(-624.068 -694.64)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6692",
    "data-name": "Group 6692",
    transform: "translate(80.415 170.042)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6691",
    "data-name": "Group 6691"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14991",
    "data-name": "Path 14991",
    d: "M588.076,962.338c-4.59,0-4.6,7.133,0,7.133S592.673,962.338,588.076,962.338Z",
    transform: "translate(-584.631 -962.338)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6694",
    "data-name": "Group 6694",
    transform: "translate(70.304 218.049)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6693",
    "data-name": "Group 6693",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14992",
    "data-name": "Path 14992",
    d: "M549.781,1140.287c-3.5,0-3.507,5.441,0,5.441S553.287,1140.287,549.781,1140.287Z",
    transform: "translate(-547.153 -1140.287)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6696",
    "data-name": "Group 6696",
    transform: "translate(114.128 228.745)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6695",
    "data-name": "Group 6695"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14993",
    "data-name": "Path 14993",
    d: "M712.752,1179.932c-4.2,0-4.208,6.528,0,6.528S716.96,1179.932,712.752,1179.932Z",
    transform: "translate(-709.599 -1179.932)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6698",
    "data-name": "Group 6698",
    transform: "translate(25.831 188.793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6697",
    "data-name": "Group 6697"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14994",
    "data-name": "Path 14994",
    d: "M384.144,1031.841a1.905,1.905,0,0,0,0,3.808A1.905,1.905,0,0,0,384.144,1031.841Z",
    transform: "translate(-382.305 -1031.841)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6700",
    "data-name": "Group 6700",
    transform: "translate(29.386 172.893)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6699",
    "data-name": "Group 6699"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14995",
    "data-name": "Path 14995",
    d: "M397.715,972.9c-2.976,0-2.981,4.625,0,4.625S400.7,972.9,397.715,972.9Z",
    transform: "translate(-395.481 -972.903)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6702",
    "data-name": "Group 6702",
    transform: "translate(20.973 141.723)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6701",
    "data-name": "Group 6701"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14996",
    "data-name": "Path 14996",
    d: "M365.831,857.364a1.588,1.588,0,0,0,0,3.173A1.588,1.588,0,0,0,365.831,857.364Z",
    transform: "translate(-364.299 -857.364)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6704",
    "data-name": "Group 6704",
    transform: "translate(185.92 110.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6703",
    "data-name": "Group 6703"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14997",
    "data-name": "Path 14997",
    d: "M977.638,745.234c2.567,0,2.571-3.989,0-3.989S975.067,745.234,977.638,745.234Z",
    transform: "translate(-975.711 -741.245)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6706",
    "data-name": "Group 6706",
    transform: "translate(169.45 87.465)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6705",
    "data-name": "Group 6705"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14998",
    "data-name": "Path 14998",
    d: "M916.937,656.247c-3.034,0-3.039,4.715,0,4.715S919.976,656.247,916.937,656.247Z",
    transform: "translate(-914.659 -656.247)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6708",
    "data-name": "Group 6708",
    transform: "translate(17.027 47.251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6707",
    "data-name": "Group 6707"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14999",
    "data-name": "Path 14999",
    d: "M351.555,511.083c2.509,0,2.513-3.9,0-3.9S349.042,511.083,351.555,511.083Z",
    transform: "translate(-349.672 -507.184)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6710",
    "data-name": "Group 6710",
    transform: "translate(0 63.744)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6709",
    "data-name": "Group 6709"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15000",
    "data-name": "Path 15000",
    d: "M288.7,568.319c-2.859,0-2.864,4.443,0,4.443S291.565,568.319,288.7,568.319Z",
    transform: "translate(-286.556 -568.319)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6712",
    "data-name": "Group 6712",
    transform: "translate(100.131 3.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6711",
    "data-name": "Group 6711"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15001",
    "data-name": "Path 15001",
    d: "M659.027,346.845a1.361,1.361,0,0,0,0,2.72A1.361,1.361,0,0,0,659.027,346.845Z",
    transform: "translate(-657.713 -346.845)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6714",
    "data-name": "Group 6714",
    transform: "translate(82.621)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6713",
    "data-name": "Group 6713"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15002",
    "data-name": "Path 15002",
    d: "M594.869,336.3c2.742,0,2.747-4.262,0-4.262S592.122,336.3,594.869,336.3Z",
    transform: "translate(-592.811 -332.037)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6716",
    "data-name": "Group 6716",
    transform: "translate(171.002 12.941)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6715",
    "data-name": "Group 6715"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15003",
    "data-name": "Path 15003",
    d: "M922.429,384.178c2.684,0,2.688-4.171,0-4.171S919.741,384.178,922.429,384.178Z",
    transform: "translate(-920.414 -380.007)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6718",
    "data-name": "Group 6718",
    transform: "translate(179.472 40.113)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6717",
    "data-name": "Group 6717"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15004",
    "data-name": "Path 15004",
    d: "M953.737,480.726c-2.567,0-2.572,3.99,0,3.99S956.308,480.726,953.737,480.726Z",
    transform: "translate(-951.81 -480.726)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6720",
    "data-name": "Group 6720",
    transform: "translate(133.942 46.153)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6719",
    "data-name": "Group 6719"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15005",
    "data-name": "Path 15005",
    d: "M785.364,507.92c3.093,0,3.1-4.806,0-4.806S782.266,507.92,785.364,507.92Z",
    transform: "translate(-783.043 -503.114)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6722",
    "data-name": "Group 6722",
    transform: "translate(104.445 55.971)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6721",
    "data-name": "Group 6721"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15006",
    "data-name": "Path 15006",
    d: "M676.506,539.506c-3.734,0-3.74,5.8,0,5.8S680.247,539.506,676.506,539.506Z",
    transform: "translate(-673.704 -539.506)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6724",
    "data-name": "Group 6724",
    transform: "translate(107.975 72.409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6723",
    "data-name": "Group 6723"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15007",
    "data-name": "Path 15007",
    d: "M689.287,600.436c-3.326,0-3.331,5.169,0,5.169S692.618,600.436,689.287,600.436Z",
    transform: "translate(-686.791 -600.436)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6726",
    "data-name": "Group 6726",
    transform: "translate(58.455 59.104)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6725",
    "data-name": "Group 6725"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15008",
    "data-name": "Path 15008",
    d: "M506.244,551.121a3.019,3.019,0,0,0-2.885,3.788l.1.3a2.954,2.954,0,0,0,2.79,2.124,3,3,0,0,0,2.791-2.124l.095-.3A3.018,3.018,0,0,0,506.244,551.121Z",
    transform: "translate(-503.231 -551.121)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6728",
    "data-name": "Group 6728",
    transform: "translate(60.492 107.489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6727",
    "data-name": "Group 6727"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15009",
    "data-name": "Path 15009",
    d: "M512.4,730.47a1.678,1.678,0,0,0,0,3.355A1.678,1.678,0,0,0,512.4,730.47Z",
    transform: "translate(-510.782 -730.47)",
    fill: "#e89740"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6730",
    "data-name": "Group 6730",
    transform: "translate(26.007 94.988)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6729",
    "data-name": "Group 6729"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15010",
    "data-name": "Path 15010",
    d: "M383.52,684.692a2.017,2.017,0,0,0-.5,1.882,1.965,1.965,0,0,0,1.865,1.42l.516-.015a1.431,1.431,0,0,0,1.4-1.4q.008-.258.015-.516A1.953,1.953,0,0,0,383.52,684.692Z",
    transform: "translate(-382.957 -684.132)",
    fill: "#e89740"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6744",
    "data-name": "Group 6744",
    transform: "translate(33.76 15.769)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6733",
    "data-name": "Group 6733",
    transform: "translate(47.026 14.541)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6732",
    "data-name": "Group 6732"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15011",
    "data-name": "Path 15011",
    d: "M516.847,394.2a8.634,8.634,0,0,0-2.214,4.846,6.79,6.79,0,0,0,.483,5.772c1.131,1.933,3.647,3.708,6,3.444.648-.073,1.367-.18,2.134-.324a6.7,6.7,0,0,0,2.192-.48c7.228-1.8,16.538-6.342,13.2-14.255C534.727,383.919,521.961,388.768,516.847,394.2Z",
    transform: "translate(-514.212 -387.978)",
    fill: "#693903"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6735",
    "data-name": "Group 6735",
    transform: "translate(164.999 37.691)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6734",
    "data-name": "Group 6734"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15012",
    "data-name": "Path 15012",
    d: "M969.782,480.254a10.992,10.992,0,0,0-1.52-1.987,6.8,6.8,0,0,0-1.992-1.444,12.46,12.46,0,0,0-2.742-1.935,8.184,8.184,0,0,0-7.983-.106,7.85,7.85,0,0,0-4.031,6.721,13.379,13.379,0,0,0,3.269,8.428,11.8,11.8,0,0,0,6.133,3.7,8.471,8.471,0,0,0,5.137-.315,7.538,7.538,0,0,0,3.89-3.222,8.508,8.508,0,0,0,.97-3.063,5.657,5.657,0,0,0-.148-3.142l-.015-.039A7.746,7.746,0,0,0,969.782,480.254Z",
    transform: "translate(-951.507 -473.79)",
    fill: "#693903"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6737",
    "data-name": "Group 6737",
    transform: "translate(0 65.535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6736",
    "data-name": "Group 6736"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15013",
    "data-name": "Path 15013",
    d: "M345.236,577.893a10.636,10.636,0,0,0-5.167,10.935,6.565,6.565,0,0,0,2.576,5.389,7.237,7.237,0,0,0,4.252,1.429,7.812,7.812,0,0,0,3.575-.6,7.35,7.35,0,0,0,4.465-5.986,11.481,11.481,0,0,0,.972-5.043A7.178,7.178,0,0,0,345.236,577.893Z",
    transform: "translate(-339.9 -576.998)",
    fill: "#693903"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6739",
    "data-name": "Group 6739",
    transform: "translate(115.446 55.425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6738",
    "data-name": "Group 6738"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15014",
    "data-name": "Path 15014",
    d: "M776.5,539.57a10.412,10.412,0,0,0-4.416,1.195,8.678,8.678,0,0,0-3.58,4.184,8.358,8.358,0,0,0-.6,4.534,8.1,8.1,0,0,0,2.407,5.023,12.5,12.5,0,0,0,4.231,2.544,14.386,14.386,0,0,0,2.074.853,15.687,15.687,0,0,0,7.206.209,8.63,8.63,0,0,0,6.016-6.017c.77-2.8.06-6.412-2.215-8.381C784.571,541.068,780.66,539.2,776.5,539.57Z",
    transform: "translate(-767.826 -539.523)",
    fill: "#693903"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6741",
    "data-name": "Group 6741",
    transform: "translate(126.174)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6740",
    "data-name": "Group 6740"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15015",
    "data-name": "Path 15015",
    d: "M825.912,346.007a7.8,7.8,0,0,0-1.616-8.539,9.926,9.926,0,0,0-4.038-2.483c-.442-.13-.9-.224-1.345-.335s-.895-.237-1.346-.335a8.4,8.4,0,0,0-5.576.558l-.06.03c-.209.1-.418.2-.629.316l.017.041a7.958,7.958,0,0,0-2.154,1.92,7.213,7.213,0,0,0-1.5,3.6,8.219,8.219,0,0,0,.9,4.857c1.151,2.5,3.608,3.352,5.942,4.326a8.35,8.35,0,0,0,4.258.848,9.652,9.652,0,0,0,3.945-1.067A7.751,7.751,0,0,0,825.912,346.007Z",
    transform: "translate(-807.593 -334.079)",
    fill: "#693903"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6743",
    "data-name": "Group 6743",
    transform: "translate(59.856 64.476)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6742",
    "data-name": "Group 6742"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15016",
    "data-name": "Path 15016",
    d: "M575.373,581.541a8.373,8.373,0,0,0,.186-1.56,7.31,7.31,0,0,0-.892-3.5,6.362,6.362,0,0,0-5.625-3.413,7,7,0,0,0-4.779,2.018,6.165,6.165,0,0,0-1.195,1.7,4.707,4.707,0,0,0-.485.686,6.471,6.471,0,0,0-.615,4.7,8.22,8.22,0,0,0,.677,1.652,6.635,6.635,0,0,0,2.337,2.308,17.966,17.966,0,0,0,1.711.712,5.366,5.366,0,0,0,.946.137q.474.065.948.127A6.7,6.7,0,0,0,575.373,581.541Z",
    transform: "translate(-561.771 -573.073)",
    fill: "#693903"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6761",
    "data-name": "Group 6761",
    transform: "translate(37.707 18.745)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6746",
    "data-name": "Group 6746",
    transform: "translate(45.699 17.883)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6745",
    "data-name": "Group 6745"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15017",
    "data-name": "Path 15017",
    d: "M528.093,416.782c.012-.021.044-.086.1-.2.07-.131.145-.258.227-.382.192-.288.012-.053.235-.289a3.333,3.333,0,0,1,.965-.7,1.954,1.954,0,0,0-1.039-3.767,5.486,5.486,0,0,0-3.816,2.962c-.672,1.031-1.177,2.323-.546,3.4a1.97,1.97,0,0,0,2.267.923C527.5,418.427,527.756,417.638,528.093,416.782Z",
    transform: "translate(-523.926 -411.394)",
    fill: "#c26507"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6748",
    "data-name": "Group 6748",
    transform: "translate(127.261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6747",
    "data-name": "Group 6747"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15018",
    "data-name": "Path 15018",
    d: "M832.241,345.768a4.448,4.448,0,0,0-2.869-.63,2.68,2.68,0,0,0-1.765.372,2.884,2.884,0,0,0-.935.949,1.87,1.87,0,0,0-.4,1.477,2.544,2.544,0,0,0,.1.684,2.024,2.024,0,0,0,1.974,1.458,3.3,3.3,0,0,0,3.145-.875,1.968,1.968,0,0,0,1.5-1.143A1.848,1.848,0,0,0,832.241,345.768Z",
    transform: "translate(-826.254 -345.108)",
    fill: "#c26507"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6750",
    "data-name": "Group 6750",
    transform: "translate(0 65.346)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6749",
    "data-name": "Group 6749"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15019",
    "data-name": "Path 15019",
    d: "M357.224,587.609a5.8,5.8,0,0,0-1.753,1.425c-.029.037-.05.078-.076.116a6.542,6.542,0,0,0-.577.841,2.173,2.173,0,0,0,2.972,2.973,10.649,10.649,0,0,0,2.383-2.405,2.161,2.161,0,0,0-.337-2.612A2.223,2.223,0,0,0,357.224,587.609Z",
    transform: "translate(-354.533 -587.328)",
    fill: "#c26507"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6752",
    "data-name": "Group 6752",
    transform: "translate(115.445 55.166)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6751",
    "data-name": "Group 6751"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15020",
    "data-name": "Path 15020",
    d: "M789.378,550.911a1.972,1.972,0,0,0-1.745-1.309,2.68,2.68,0,0,0-.83.07,4.174,4.174,0,0,0-3.81,1.57,1.952,1.952,0,0,0-.292,2.262,1.9,1.9,0,0,0,2.108.858l1.644-.49a1.632,1.632,0,0,0,1.308-.391l.381-.114a2.223,2.223,0,0,0,.414-.173,1.383,1.383,0,0,0,.826-2.28Z",
    transform: "translate(-782.455 -549.595)",
    fill: "#c26507"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6754",
    "data-name": "Group 6754",
    transform: "translate(165.206 37.404)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6753",
    "data-name": "Group 6753"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15021",
    "data-name": "Path 15021",
    d: "M972.029,484.906a2.361,2.361,0,0,0-2.536-1.1,2.21,2.21,0,0,0-.467.153,2.154,2.154,0,0,0-2.118,2.217,2.313,2.313,0,0,0,2.291,2.235c.044,0,.087-.006.13-.008a2.389,2.389,0,0,0,1.047-.019,2.539,2.539,0,0,0,1.973-2.641,1.76,1.76,0,0,0-.3-.8C972.04,484.933,972.037,484.919,972.029,484.906Z",
    transform: "translate(-966.909 -483.755)",
    fill: "#c26507"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6756",
    "data-name": "Group 6756",
    transform: "translate(61.472 64.107)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6755",
    "data-name": "Group 6755"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15022",
    "data-name": "Path 15022",
    d: "M585.5,582.847a2.294,2.294,0,0,0-2.391.671,1.451,1.451,0,0,0-.67.92,1.721,1.721,0,0,0,3.142,1.324c.024-.046.031-.1.052-.148a1.528,1.528,0,0,0,.907-1.175A1.463,1.463,0,0,0,585.5,582.847Z",
    transform: "translate(-582.392 -582.736)",
    fill: "#c26507"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6758",
    "data-name": "Group 6758",
    transform: "translate(187.681 65.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6757",
    "data-name": "Group 6757"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15023",
    "data-name": "Path 15023",
    d: "M1061.308,587.957a8.394,8.394,0,0,0-1.31-.867,7.311,7.311,0,0,0-3.523-.773,6.364,6.364,0,0,0-5.577,3.491,6.991,6.991,0,0,0-.345,5.176,6.155,6.155,0,0,0,.978,1.829,4.713,4.713,0,0,0,.395.741,6.468,6.468,0,0,0,3.924,2.663,8.247,8.247,0,0,0,1.78.137,6.642,6.642,0,0,0,3.113-1.051,18.116,18.116,0,0,0,1.405-1.209,5.323,5.323,0,0,0,.548-.783q.272-.395.54-.79A6.7,6.7,0,0,0,1061.308,587.957Z",
    transform: "translate(-1050.218 -586.317)",
    fill: "#693903"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6760",
    "data-name": "Group 6760",
    transform: "translate(190.792 68.066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6759",
    "data-name": "Group 6759"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15024",
    "data-name": "Path 15024",
    d: "M1062.376,597.878a2.294,2.294,0,0,0-.476,2.437,1.452,1.452,0,0,0,.521,1.012,1.722,1.722,0,0,0,2.6-2.212c-.03-.042-.075-.073-.11-.112a1.527,1.527,0,0,0-.642-1.338A1.462,1.462,0,0,0,1062.376,597.878Z",
    transform: "translate(-1061.746 -597.411)",
    fill: "#c26507"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6785",
    "data-name": "Group 6785",
    transform: "translate(211.704 386.159)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6772",
    "data-name": "Group 6772",
    transform: "translate(109.717 84.332)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6763",
    "data-name": "Group 6763"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15025",
    "data-name": "Path 15025",
    d: "M689.272,999.225c-2.461-2.677-7.835-.363-16.132-.363s-13.859-2.264-16.245.363a5.5,5.5,0,0,0-1.215,4.486,8.651,8.651,0,0,0,.214,1.078c1.258,4.86,6.943,7.5,16.3,7.826.29.01.579.023.876.023a25.226,25.226,0,0,0,4.7-.433c7.435-1.406,12.1-3.151,12.948-7.468a7.339,7.339,0,0,0,.125-1.092A5.988,5.988,0,0,0,689.272,999.225Z",
    transform: "translate(-655.622 -997.934)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6771",
    "data-name": "Group 6771"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6764",
    "data-name": "Group 6764"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15026",
    "data-name": "Path 15026",
    d: "M673.168,1000.053c15.562,0,19.513-.723,14.155,4.475,1.577-.34,2.746-.653,3.523-.884a5.988,5.988,0,0,0-1.575-4.419c-2.461-2.677-7.835-.363-16.132-.363s-13.859-2.264-16.245.363a5.5,5.5,0,0,0-1.215,4.486c.649.188,1.524.42,2.641.674C651.739,996.947,665.193,1000.053,673.168,1000.053Z",
    transform: "translate(-655.622 -997.934)",
    fill: "#e89740"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6765",
    "data-name": "Group 6765",
    transform: "translate(0.272 6.855)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15027",
    "data-name": "Path 15027",
    d: "M659.739,1023.717c-.989-.083-2.053-.2-3.108-.372,1.258,4.86,6.943,7.5,16.3,7.826C660.166,1029.728,659.7,1025.243,659.739,1023.717Z",
    transform: "translate(-656.631 -1023.345)",
    fill: "#e89740"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6766",
    "data-name": "Group 6766",
    transform: "translate(22.151 6.803)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15028",
    "data-name": "Path 15028",
    d: "M750.679,1023.15a43.334,43.334,0,0,1-4.375.5c3.847,4.373-2.57,5.018-8.572,6.972C745.166,1029.213,749.835,1027.467,750.679,1023.15Z",
    transform: "translate(-737.731 -1023.15)",
    fill: "#e89740"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6767",
    "data-name": "Group 6767",
    transform: "translate(27.206 6.595)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15029",
    "data-name": "Path 15029",
    d: "M760.964,1022.379c-1.241.268-2.729.552-4.495.827,0,0,1.5.011,3.517-.123-.1-.109-.189-.218-.3-.328A3.809,3.809,0,0,0,760.964,1022.379Z",
    transform: "translate(-756.469 -1022.379)",
    fill: "#e89740"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6768",
    "data-name": "Group 6768",
    transform: "translate(30.426 5.711)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15030",
    "data-name": "Path 15030",
    d: "M768.4,1020.362c.109.11.2.219.3.328a43.346,43.346,0,0,0,4.375-.5,7.331,7.331,0,0,0,.125-1.092c-.777.231-1.946.544-3.523.884A3.81,3.81,0,0,1,768.4,1020.362Z",
    transform: "translate(-768.403 -1019.102)",
    fill: "#e89740"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6769",
    "data-name": "Group 6769",
    transform: "translate(2.699 6.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15031",
    "data-name": "Path 15031",
    d: "M666.309,1022.623c2.481.209,4.465.194,4.465.194-2.086-.325-3.79-.663-5.146-.971a4.15,4.15,0,0,0,.7.5S666.314,1022.446,666.309,1022.623Z",
    transform: "translate(-665.628 -1021.847)",
    fill: "#e89740"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6770",
    "data-name": "Group 6770",
    transform: "translate(0.058 5.778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15032",
    "data-name": "Path 15032",
    d: "M659.176,1020.519a4.154,4.154,0,0,1-.7-.5c-1.117-.254-1.992-.486-2.641-.674a8.617,8.617,0,0,0,.214,1.078c1.055.17,2.119.289,3.108.372C659.165,1020.622,659.176,1020.519,659.176,1020.519Z",
    transform: "translate(-655.838 -1019.35)",
    fill: "#e89740"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6784",
    "data-name": "Group 6784",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6773",
    "data-name": "Group 6773"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15033",
    "data-name": "Path 15033",
    d: "M501.935,704.2c-1.076,1.458-4.689,3.482-7.358,4.852.1,1.109.179,7,.179,8.2,0,21.792,2.648,60.691-52.667,60.691-38,0-54.606-27.328-57.365-54.2h-.142s-1.5-7.926-8.318-7.926-8.319,7.926-8.319,7.926h-.14c-2.76,26.877-19.369,54.2-57.368,54.2-55.316,0-52.665-38.9-52.665-60.691,0-1.2.084-7.09.175-8.2-2.665-1.37-6.277-3.394-7.356-4.852-1.661-2.248-2.154-6.336-1.118-6.939,3.648-2.133,12.95-6.517,26.613-9.405,14.05-2.97,48.172-4.775,78.78,3.57,9.529,2.6,32.86,2.75,42.794,0,30.538-8.453,64.733-6.541,78.78-3.57,13.663,2.888,22.966,7.272,26.616,9.405C504.089,697.869,503.6,701.956,501.935,704.2Z",
    transform: "translate(-248.931 -685.339)",
    fill: "#00111a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6774",
    "data-name": "Group 6774",
    transform: "translate(17.264 8.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15034",
    "data-name": "Path 15034",
    d: "M406.559,741.831c0-16.1-17.255-24.06-47.431-24.06s-46.185,5.255-46.185,25.5c0,18.463-2.243,51.417,44.618,51.417C393.041,794.69,406.559,766.569,406.559,741.831Z",
    transform: "translate(-312.926 -717.771)",
    fill: "#353b42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6775",
    "data-name": "Group 6775",
    transform: "translate(143.765 8.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15035",
    "data-name": "Path 15035",
    d: "M875.447,743.273c0-20.248-16.006-25.5-46.185-25.5s-47.431,7.963-47.431,24.06c0,24.738,13.521,52.859,49,52.859C877.692,794.69,875.447,761.736,875.447,743.273Z",
    transform: "translate(-781.83 -717.771)",
    fill: "#353b42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6776",
    "data-name": "Group 6776",
    transform: "translate(48.931 38.806)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15036",
    "data-name": "Path 15036",
    d: "M481.42,833.844c-6.361-10.187-17.164-1.72-30.775,6.779s-24.876,13.812-18.514,24,22.552,11.556,36.163,3.056S487.781,844.032,481.42,833.844Z",
    transform: "translate(-430.306 -829.184)",
    fill: "#292e33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6777",
    "data-name": "Group 6777",
    transform: "translate(179.647 38.806)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15037",
    "data-name": "Path 15037",
    d: "M965.949,833.844c6.361,10.187.484,25.336-13.127,33.835s-29.8,7.131-36.163-3.056,4.9-15.5,18.514-24S959.589,823.657,965.949,833.844Z",
    transform: "translate(-914.835 -829.183)",
    fill: "#292e33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6780",
    "data-name": "Group 6780",
    transform: "translate(21.809 18.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6778",
    "data-name": "Group 6778"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15038",
    "data-name": "Path 15038",
    d: "M337.295,755.752c3.044.158,2.514,6.055,1.551,12.815s-1.992,11.823-5.036,11.665-4.732-5.766-3.77-12.526S334.251,755.594,337.295,755.752Z",
    transform: "translate(-329.77 -755.748)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6779",
    "data-name": "Group 6779",
    transform: "translate(0.772 30.717)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1199",
    "data-name": "Ellipse 1199",
    cx: 3.358,
    cy: 4.967,
    rx: 3.358,
    ry: 4.967,
    transform: "translate(0 1.017) rotate(-8.71)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6783",
    "data-name": "Group 6783",
    transform: "translate(151.62 18.231)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6781",
    "data-name": "Group 6781"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15039",
    "data-name": "Path 15039",
    d: "M818.47,752.921c3.044.158,2.513,6.055,1.551,12.815s-1.991,11.823-5.036,11.665-4.732-5.766-3.77-12.526S815.426,752.763,818.47,752.921Z",
    transform: "translate(-810.945 -752.917)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6782",
    "data-name": "Group 6782",
    transform: "translate(1.439 31.199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15040",
    "data-name": "Path 15040",
    d: "M823,872.99c.416,2.712-.734,5.137-2.567,5.418s-3.656-1.69-4.071-4.4.734-5.137,2.567-5.418S822.587,870.279,823,872.99Z",
    transform: "translate(-816.28 -868.562)",
    fill: "#fff"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookieImg);
export default __webpack_public_path__ + "static/media/cookie-img.706e2ded.svg";
export { ForwardRef as ReactComponent };